export const theme = {
    colors: {
        forestGreen: "#27AF37",
        emerald: "#53CF61",
        thunderbird: "#C41C1C",
        redOrange: "#F93B3B",
        white: "#ffffffff",
        twine: "#dfdad0ff",
        black: "#010101",
        ebb: "#EFEBEB",
        antiqueBronze: "#6d4d08ac",
        brightGrey: "#888888",
        teal: "#008080",
        brightTeal: "#26dfdfff",
    },
    breakpoints: {
        mobile: 767,
    },
} as const; // teraz pod kolorami nie będzie string, tylko konkretna wartość